import { _ } from "../../../../core/polyglot/polyglot.js";
import dialog from "../../../../core/widgets/dialog.js";
import selection from "../../../../models/accounting/document/selection.js";

/**
 * I am the widget used to delete entries.
 * I display a popup asking the user confirmation about the
 * permanent deletion of the entries.
 * I should only be used through the proper command.
 */

/**
 * Todo: Add JSDoc comment
 */
export default function deleteEntriesDialog(command, my) {
	my ||= {};

	const that = dialog({}, my);

	const type = command.entryType();

	my.title = _("Delete {type}", {
		type,
	});

	my.content = function (html) {
		html.render(
			_("Are you sure you want to {em: permanently} remove: {items}", {
				em: (text) => (html) => html.tag("em", text),
				items: function (html) {
					html.ul(selection.itemNames().map((name) => html.li(name)));
				},
			}),
		);
	};

	my.footer = function (html) {
		html.button(
			{
				class: "btn btn-danger",
				"data-test": "confirm-delete",
				click: deleteEntry,
			},
			_("Delete"),
		);

		html.button(_("Cancel")).addClass("btn primary").click(that.hide);
	};

	function deleteEntry() {
		that.hide();
		command.doPerform();
	}

	return that;
}
